// @flow

import ko from 'rgs-knockout';
import type {Observable, PureComputed} from 'rgs-knockout';

const delay = (...args) => setTimeout(...args);
const makeClasses = css => ({css});

export default class SmartMenu {
	props: {
		checker: PureComputed<boolean>,
	};
	_isMenuHidden: Observable<boolean>;
	_isMenuChecked: Observable<boolean>;

	constructor (options: any) {
		const {isMenuChecked, isMenuHidden} = options || {};

		this._isMenuHidden = ko.unwrap(isMenuHidden) || ko.observable(true);
		this._isMenuChecked = ko.unwrap(isMenuChecked) || ko.observable(false);

		this.props = {
			checker: ko.pureComputed({
				read: this.onCheckerRead,
				write: this.onCheckerWrite,
			}),
			...this.getMenuClasses(),
		};
	}

	onCheckerRead = () => this._isMenuChecked();
	onCheckerWrite = (isMenuChecked: boolean) => {
		let delayedCall = null;

		if (isMenuChecked) {
			this._isMenuHidden(false);

			delayedCall = () => this._isMenuChecked(true);
		} else {
			this._isMenuChecked(false);

			delayedCall = () => this._isMenuHidden(true);
		}

		delay(delayedCall, 20);
	};


	isCheckerActive = (): boolean => {
		return this.props.checker() === true;
	};

	isCheckerInactive = (): boolean => {
		return this.props.checker() === false;
	};


	getMenuClasses () {
		return {
			menu: makeClasses({
				'nfd-anim-item-ui-pulled-out': ko.pureComputed(this.isCheckerActive),
				'nfd-anim-item-ui-hidden': ko.pureComputed(this.isCheckerInactive),
				'nfd-anim-item-ui': true,

				'hidden': ko.pureComputed(this._isMenuHidden),
			}),
			switcher: makeClasses({
				'nfd-anim-hamburger-is-active': ko.pureComputed(this.isCheckerActive),
				'nfd-anim-hamburger': true,
			}),
		};
	}
}
